/**
 * A single readiness check shared by every transport action surface: is
 * there an active CI/CD pipeline for the space (project bound and a GitHub
 * token stored)? If not, the start/release buttons give way to a blocker
 * linking to the setup page. The backend rejects dispatches without a token
 * with a 400 anyway, but the user should not even start the flow.
 *
 * One fetch per space, no polling; useCicdRun takes over polling once a run
 * has started.
 *
 * Also returns the transport mode. In SAP mode the Partner Directory is not carried along, and
 * the wizard has to know: otherwise the user selects entries, sees them in the summary, the run
 * turns green - and nothing arrives in the target.
 */
import { useEffect, useState } from "react";
import { api } from "../../../utils/helpers";

export function usePipelineReady(spaceId) {
  const [state, setState] = useState({ loading: true, ready: false, tokenSet: false, configured: false, modus: "erweitert" });

  useEffect(() => {
    if (!spaceId) { setState({ loading: false, ready: false, tokenSet: false, configured: false, modus: "erweitert" }); return; }
    let alive = true;
    setState(s => ({ ...s, loading: true }));
    api(`/api/cicd/pipeline/overview?spaceId=${encodeURIComponent(spaceId)}`)
      .then(r => {
        if (!alive) return;
        const tokenSet = !!r?.health?.tokenSet;
        const configured = r?.configured !== false;
        // Only the explicit value switches; if it is missing, extended mode applies.
        const modus = r?.transportModus === "sap" ? "sap" : "erweitert";
        setState({ loading: false, tokenSet, configured, modus, ready: tokenSet && configured });
      })
      .catch(() => { if (alive) setState({ loading: false, ready: false, tokenSet: false, configured: false, modus: "erweitert" }); });
    return () => { alive = false; };
  }, [spaceId]);

  return state;
}
